import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['toggle'];

  toggleClickHandler() {
    const newExpanded = !(this.toggleTarget.getAttribute('aria-expanded') === 'true');

    this.toggleTarget.setAttribute('aria-expanded', String(newExpanded));

    if (newExpanded) {
      const rect = this.element.getBoundingClientRect();
      this.element.style.setProperty('--c-dashboard-menu-top', `${rect.top}px`);
    }
  }
}
